import { render, staticRenderFns } from "./Top5InsectTypesPieChart.vue?vue&type=template&id=b7de2216&"
import script from "./Top5InsectTypesPieChart.vue?vue&type=script&lang=js&"
export * from "./Top5InsectTypesPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Top5InsectTypesPieChart.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7de2216')) {
      api.createRecord('b7de2216', component.options)
    } else {
      api.reload('b7de2216', component.options)
    }
    module.hot.accept("./Top5InsectTypesPieChart.vue?vue&type=template&id=b7de2216&", function () {
      api.rerender('b7de2216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/Top5InsectTypesPieChart.vue"
export default component.exports